import React from 'react';
import styled, { keyframes } from 'styled-components';

interface AlertLoaderProps {
  message?: string;
}

const AlertLoader: React.FC<AlertLoaderProps> = ({ message = "Loading..." }) => {
  return (
    <Overlay>
      <LoaderContainer>
        <Spinner />
        <LoaderText>{message}</LoaderText>
      </LoaderContainer>
    </Overlay>
  );
};

export default AlertLoader;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
`;

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #0173C6;
  border-radius: 50%;
  animation: ${spin} 1.5s ease-in-out infinite;
`;

const LoaderText = styled.p`
  margin-top: 12px;
  color: #0173C6;
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
`;
